<template>
  <div class="panel-navigation">
    <custom-logo v-if="is_mobile()" class="panel-navigation__logo" />
    <availability :name="name" class="panel-navigation__user" />
    <navigation class="panel-navigation__menu" />
  </div>
</template>

<script>
import Availability from './availability.vue'
import Navigation from './navigation.vue'
import CustomLogo from '@/components/customizations/custom-logo'

export default {
  name: 'panel-navigation',

  components: {
    'availability': Availability,
    'navigation': Navigation,
    'custom-logo': CustomLogo,
  },

  props: {
    name: String
  },

  data() {
    return {
    }
  },

  computed: {
  },

  created() {
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>

  .panel-navigation {
    position: absolute;
    right: 0;
    top: calc(100% + 15px);
    background-color: $white;
    box-shadow: 0 0 15px 0 rgba(0, 0, 0, .1);
    border-radius: $border-radius-lg * 2;
    padding: $grid-gutter-20;
    min-width: 200px;

    &__logo {
      margin-bottom: $grid-gutter-width / 2;
    }

    &__user {
      border-bottom: 1px solid $gray-200;
      padding-bottom: $grid-gutter-width / 3;
      line-height: normal;
    }

    ::v-deep {

      .availability {

        &__credits {
          margin-top: $grid-gutter-width / 6;
        }

        &__icon{
          display: none;
        }
      }
    }
  }

</style>